export const keyboardNavigationPress = (callback) => {
  return function (event) {
    const key = event.key;

    if (key === 'Enter' || key === ' ') {
      event.preventDefault(); // Förhindra exempelvis att sidan scrollar vid Space
      callback();
    }
  };
}